<script setup>
import { onMounted, ref } from 'vue';
import { RouterLink } from 'vue-router';
import router from '@/router';
import { API } from '@/services/index';
import { GRANT_USERS_INTO_ACCOUNT } from '@/services/account/mutations/account/index.js';
import { useMutation } from '@tanstack/vue-query';
import { useSetupStore } from '@/stores/setup.store.js';

// const { value, errorMessage } = useField(
//   'email',
//   yup
//     .string()
//     .email()
//     .matches(/^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/, 'email must be a valid email')
// );

const setup = useSetupStore();
const newAccount = ref(localStorage.getItem('_pup_new_account') ? JSON.parse(localStorage.getItem('_pup_new_account')) : false);
const accountTypes = computed(() => useSetupStore().accountTypes);
const backButtonHref = ref(setup.getAccountType === 1 ? '/onboard/social-connect' : '/onboard');
const isFormValid = ref(false);
const isLoading = ref(false);
const inviteErrors = ref(null);
let invitedTeamMembers = ref([
  { id: 1, email: '', role: '' },
  { id: 2, email: '', role: '' },
  { id: 3, email: '', role: '' },
  { id: 4, email: '', role: '' },
  { id: 5, email: '', role: '' },
  { id: 6, email: '', role: '' }
]);

const mappedTeamMembers = computed(() => {
  return invitedTeamMembers.value
    .filter((member) => member.email !== '' && member.role !== '')
    .map((member) => {
      return {
        email: member.email,
        role: member.role
      };
    });
});

onMounted(() => {
  if (setup.getAccountInvitedTeamMembers) {
    invitedTeamMembers.value = setup.getAccountInvitedTeamMembers;
  }
});

// const addNewTeamMember = () => {
//   if (invitedTeamMembers.value.length <= 6) {
//     invitedTeamMembers.value.push({
//       id: invitedTeamMembers.value.length + 1,
//       email: '',
//       role: ''
//     });
//   }
// };

const inviteTeamMembersHandler = () => {
  isLoading.value = true;

  const payload = {
    account_id: newAccount.value.id,
    users: mappedTeamMembers.value
  };

  inviteUsersMutation.mutateAsync(payload);
};

const inviteUsersMutation = useMutation({
  mutationFn: async (payload) => {
    return await API.sendQuery('/graphql/account', GRANT_USERS_INTO_ACCOUNT, payload);
  },
  onSuccess: (data) => {
    if (data.data.errors) {
      isLoading.value = false;
      inviteErrors.value = data.data.errors;
    }

    if (data.data.data.grantUsers) {
      localStorage.setItem('_new_account_invited_team_members', JSON.stringify(mappedTeamMembers.value));
      router.push('/onboard/create-project');
    }
  },
  onError: (error) => {
    isLoading.value = false;
    console.log('error', error);
    inviteErrors.value = 'System error. Please try again later.';
  }
});
</script>

<template>
  <div>
    <div class="tw-text-center">
      <h3 class="tw-font-mono tw-text-lg tw-font-bold tw-text-primary-blue">Invite Team Members.</h3>
      <div class="tw-text-[0.813rem]">Invite people to your account and collaborate on a project or at a workspace level.</div>
    </div>
    <div class="tw-my-8">
      <v-form v-model="isFormValid">
        <template v-for="(member, index) in invitedTeamMembers" :key="member.id">
          <div class="tw-my-3 tw-flex tw-w-full tw-justify-between tw-space-x-3">
            <v-text-field
              class="tw-w-10"
              v-model="member.email"
              variant="outlined"
              color="primary-blue"
              placeholder="Email Address"
              hide-details="auto"
              density="compact"
              :disabled="isLoading"
            >
            </v-text-field>
            <v-select
              class="tw-w-1"
              v-model="member.role"
              variant="outlined"
              density="compact"
              color="primary-blue"
              label=""
              item-title="name"
              item-value="role"
              placeholder="Role"
              hide-details="auto"
              :items="accountTypes"
              :disabled="isLoading"
            >
            </v-select>
          </div>
        </template>
        <!--        <template v-if="invitedTeamMembers.length <= 6">-->
        <!--          <v-btn color="primary-blue" size="small" variant="text" class="tw-capitalize" @click="addNewTeamMember" :disabled="isLoading">-->
        <!--            <span class="tw-text-[12px]">+ More People</span>-->
        <!--          </v-btn>-->
        <!--        </template>-->
      </v-form>
    </div>
    <div class="tw-w-full">
      <v-btn
        color="primary-blue"
        size="large"
        rounded="lg"
        block
        flat
        class="tw-font-bold tw-capitalize"
        style="letter-spacing: 0px"
        @click="inviteTeamMembersHandler"
        :disabled="isLoading"
        :loading="isLoading"
      >
        Continue
      </v-btn>
      <div class="tw-mt-3 tw-flex tw-justify-between">
        <RouterLink class="tw-text-[0.75rem] tw-font-bold tw-text-[#9B9B9B]" :to="backButtonHref"> Back </RouterLink>
        <RouterLink class="tw-text-[0.75rem] tw-font-bold tw-text-primary-blue" to="/onboard/create-project"> Skip </RouterLink>
      </div>
      <div class="tw-my-5">
        <v-progress-linear class="tw-mt-4" color="primary-blue" model-value="75"></v-progress-linear>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
